import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function WedoNurs() {
  return (
    <section className="centerimg_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="text-center m-auto"
          >
            <h2>
              What Did <span style={{ color: "#6D4FC1" }}>We Do?</span>
            </h2>
            <p>
              Upon assignment, our digital solution experts closely analyzed the
              idea and presented a blueprint to build an application that would
              contain all the features and have a superior experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <div className="img_come">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/tek_img_05.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1095}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WedoNurs;
